function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M24.434 15.848L56.586 48 48 56.586 15.849 24.434 9.839 9.838l14.595 6.01zM24.5 15.5l-9 9" stroke="#F37" strokeWidth="2" /><path d="M52.707 61.293L47.914 56.5l8.586-8.586 4.793 4.793a6.071 6.071 0 0 1-8.586 8.586zM19.988 62.574L9.403 51.99l13.609-14.063L33.597 48.51 19.988 62.575zM37.914 23.5L52 9.414 62.586 20 48.5 34.086 37.914 23.5zM24 58l-5.5-5.5M58 24l-5.5-5.5M52.5 29.5l-4-4M29.5 52.5l-4-4" stroke="#F37" strokeWidth="2" /></svg>;
});